import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import usePolling from 'Shared/hooks/usePolling'
import useSessionStatusData from './useSessionStatusData'
import { JobStatusEnum, CloningStatusEnum } from '../constants'
import { pollCloneSessionJobsByID } from '../reducers/clone_leagues_sessions_jobs_poller'

const POLL_INTERVAL = 3000

const TERMINAL_SESSION_STATUSES = [
  CloningStatusEnum.COMPLETED,
  CloningStatusEnum.ERROR,
  CloningStatusEnum.TIMEOUT,
]

export const useJobsPolling = () => {
  const dispatch = useDispatch()
  const { sessionID, currentSession, polledJobsList } = useSessionStatusData()

  const pollFn = useCallback(() => {
    if (sessionID) {
      dispatch(pollCloneSessionJobsByID(sessionID))
    }
  }, [ sessionID, dispatch, pollCloneSessionJobsByID ])

  const shouldPoll = useCallback(() => {
    if (TERMINAL_SESSION_STATUSES.includes(currentSession?.status)) {
      return false
    }

    return polledJobsList?.length === 0 || polledJobsList?.some(
      job => [
        JobStatusEnum.SCHEDULED,
        JobStatusEnum.IN_PROGRESS,
      ].includes(job?.job?.status),
    )
  }, [ sessionID, currentSession, polledJobsList ])

  // usePolling's eager fire happens on mount when sessionID is still null.
  // This ensures an immediate fetch whenever the popup opens for any session,
  // regardless of status (the interval then takes over for non-terminal sessions).
  useEffect(() => {
    if (sessionID) {
      dispatch(pollCloneSessionJobsByID(sessionID))
    }
  }, [ sessionID ])

  usePolling({
    pollFn,
    shouldPoll,
    interval: POLL_INTERVAL,
    withEagerPolling: true,
  })
}

export default useJobsPolling
